import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { X, AlertTriangle, Info } from 'lucide-react';

const ConfirmModal = ({
    isOpen,
    onClose,
    onConfirm,
    title,
    message,
    confirmText = "Confirmar",
    cancelText = "Cancelar",
    type = 'danger',
    confirmDisabled = false,
    confirmTooltip = ""
}) => {
    const isDanger = type === 'danger';

    return (
        <Dialog.Root open={isOpen} onOpenChange={(open) => !open && onClose()}>
            <Dialog.Portal>
                <Dialog.Overlay
                    className="step-media-url-modal-overlay"
                    style={{
                        zIndex: 3000,
                        backgroundColor: 'rgba(0, 0, 0, 0.4)',
                        backdropFilter: 'blur(4px)'
                    }}
                />
                <Dialog.Content
                    className="confirm-modal-content"
                    style={{
                        zIndex: 3001,
                        maxWidth: '450px',
                        width: '90%',
                        padding: 0,
                        overflow: 'hidden',
                        position: 'fixed',
                        top: '40%', // Slightly above center
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        display: 'flex',
                        flexDirection: 'column',
                        borderRadius: '12px',
                        background: '#ffffff',
                        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
                    }}
                >
                    <div style={{ padding: '1.25rem 1.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #f3f4f6' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                            {isDanger ? (
                                <AlertTriangle size={24} color="#ef4444" />
                            ) : (
                                <Info size={24} color="#6c2396" />
                            )}
                            <Dialog.Title style={{ margin: 0, fontSize: '1.25rem', fontWeight: 700, color: '#111827' }}>
                                {title}
                            </Dialog.Title>
                        </div>
                        <Dialog.Close asChild>
                            <button
                                style={{
                                    background: 'transparent',
                                    border: 'none',
                                    color: '#9ca3af',
                                    cursor: 'pointer',
                                    padding: '4px',
                                    borderRadius: '4px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f3f4f6'}
                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                            >
                                <X size={20} />
                            </button>
                        </Dialog.Close>
                    </div>

                    <div style={{ padding: '1.5rem', color: '#4b5563', fontSize: '1rem', lineHeight: '1.5' }}>
                        {message}
                    </div>

                    <div style={{
                        padding: '1rem 1.5rem',
                        background: '#f9fafb',
                        display: 'flex',
                        justifyContent: 'flex-end',
                        gap: '0.75rem',
                        borderTop: '1px solid #f3f4f6'
                    }}>
                        <button
                            onClick={onClose}
                            style={{
                                padding: '0.625rem 1.25rem',
                                borderRadius: '8px',
                                border: '1px solid #d1d5db',
                                background: '#ffffff',
                                color: '#374151',
                                fontWeight: 600,
                                fontSize: '0.875rem',
                                cursor: 'pointer',
                                transition: 'all 0.2s'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#f3f4f6';
                                e.currentTarget.style.borderColor = '#c0c4cc';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = '#ffffff';
                                e.currentTarget.style.borderColor = '#d1d5db';
                            }}
                        >
                            {cancelText}
                        </button>
                        <button
                            onClick={() => {
                                if (!confirmDisabled) {
                                    onConfirm();
                                    onClose();
                                }
                            }}
                            disabled={confirmDisabled}
                            title={confirmTooltip}
                            style={{
                                padding: '0.625rem 1.25rem',
                                borderRadius: '8px',
                                border: 'none',
                                background: confirmDisabled ? '#9ca3af' : (isDanger ? '#ef4444' : '#6c2396'),
                                color: '#ffffff',
                                fontWeight: 600,
                                fontSize: '0.875rem',
                                cursor: confirmDisabled ? 'not-allowed' : 'pointer',
                                transition: 'all 0.2s',
                                boxShadow: confirmDisabled ? 'none' : '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
                            }}
                            onMouseEnter={(e) => {
                                if (!confirmDisabled) {
                                    e.currentTarget.style.backgroundColor = isDanger ? '#dc2626' : '#5a1d7f';
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (!confirmDisabled) {
                                    e.currentTarget.style.backgroundColor = isDanger ? '#ef4444' : '#6c2396';
                                }
                            }}
                        >
                            {confirmText}
                        </button>
                    </div>
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>
    );
};

export default ConfirmModal;
